var React = require('react');

function Thunder (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.7898 0.390866L0.766491 17.276C0.26075 17.9317 0.72639 18.8845 1.55258 18.8845H5.84355C6.50038 18.8845 6.97666 19.5124 6.80176 20.1479L3.88891 30.7311C3.59043 31.8156 5.03002 32.4893 5.66584 31.5628L18.2677 13.1979C18.722 12.536 18.2498 11.6342 17.449 11.6342L14.9058 11.6342C14.2879 11.6342 13.8197 11.0744 13.9268 10.4636L15.555 1.1745C15.7348 0.148703 14.4251 -0.432741 13.7898 0.390866Z"}));
}

Thunder.defaultProps = {"width":"19","height":"32","viewBox":"0 0 19 32","fill":"none"};

module.exports = Thunder;

Thunder.default = Thunder;
